import { Container, Typography } from '@cleartrip/ct-design-components'
import React from 'react'

import ImageBlock from '@/components/imageBlock'
import { FareFamilyHeaderType } from '@/types/srp'
import { getFlightLogoUrl } from '@/utils/images'

const LEG_LABELS = ['Onward:', 'Return:']

type PELegTabRowProps = {
    headerDetails: FareFamilyHeaderType[]
    selectedTabIndex: number
    onSelect: (index: number) => void
    legTimeColor?: string
    legActiveIndicatorColor?: string
}

/**
 * RT leg switcher under the interstitial title — Figma 562:25178 / 562:37236.
 * Each tab is label + circular airline logo + departure–arrival time only
 * (no duration / stops).
 */
const PELegTabRow: React.FC<PELegTabRowProps> = ({
    headerDetails,
    selectedTabIndex,
    onSelect,
    legTimeColor = '#1A1A1A',
    legActiveIndicatorColor = '#1A1A1A',
}) => (
    <Container className="w-100p">
        <Container className="flex pl-6 pr-5" css={{ gap: '32px' }}>
            {headerDetails.map((leg, index) => {
                const isActive = selectedTabIndex === index
                const { airlineCode, isMultiAirline, departureTime, arrivalTime } = leg
                const timeRange = [departureTime, arrivalTime].filter(Boolean).join(' - ')

                return (
                    <Container
                        key={`${airlineCode}-${departureTime}-${index}`}
                        className="flex flex-column flex-middle flex-rg-3 pt-4 c-pointer"
                        css={{
                            minWidth: isActive ? '188px' : 'auto',
                        }}
                        onClick={() => onSelect(index)}
                    >
                        <Container className="flex flex-middle flex-cg-2">
                            <Typography colorCode="#808080" variant="B3">
                                {LEG_LABELS[index] ?? `Leg ${index + 1}:`}
                            </Typography>
                            <Container css={{ height: '20px', width: '20px', flexShrink: 0 }}>
                                <ImageBlock
                                    isCircleLogo
                                    altText={airlineCode}
                                    customClass="o-hidden"
                                    height={20}
                                    isMultiAirline={isMultiAirline}
                                    path={getFlightLogoUrl(airlineCode)}
                                    width={20}
                                />
                            </Container>
                            <Typography colorCode={legTimeColor} variant="B2">
                                {timeRange}
                            </Typography>
                        </Container>
                        <Container
                            className="br-16 w-100p"
                            css={{
                                minWidth: '184px',
                                height: '2px',
                                backgroundColor: isActive ? legActiveIndicatorColor : 'transparent',
                            }}
                        />
                    </Container>
                )
            })}
        </Container>
    </Container>
)

export default PELegTabRow
